import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/analysis.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/aparat.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/bag.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/chart.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/check.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/clock.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/cross.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/gtick.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/guard.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/headphones.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/keypad.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/lock.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/net.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/prompt.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/social.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/star.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/thunder.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/tick.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/trust-badges/zarinpal.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/spices/background-spice.tsx");
